import React from 'react';
import './Header.css';
import logo from '../../images/logo/logo.png';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className='px-5 mx-auto sticky top-0 z-50'>
            <div className='header'>
                <div className="navbar bg-base-100">
                    <div className="navbar-start">
                        <div className="dropdown">
                            <label tabIndex={0} className="btn btn-ghost lg:hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                            </label>
                            <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                                <li><Link to='/home'>Home</Link></li>
                                <li><Link to='/projects'>Project</Link></li>
                                <li><Link to='/article'>Article</Link></li>
                                <li><Link to='/expertise'>Expertise</Link></li>
                                <li><Link to='/contact'>Contact</Link></li>
                                <li><Link to='/about'>About</Link></li>
                            </ul>
                        </div>
                        <Link to='/' className="btn btn-ghost normal-case text-xl">
                            <img className='w-10 mr-2' src={logo} alt="" />
                            <h2>MD NURUL AMIN</h2>
                        </Link>
                    </div>
                    <div className="navbar-center hidden lg:flex">
                        <ul className="menu menu-horizontal px-1">
                            <li><Link to='/home'>Home</Link></li>
                            <li><Link to='/projects'>Project</Link></li>
                            <li><Link to='/article'>Article</Link></li>
                            <li><Link to='/expertise'>Expertise</Link></li>
                            <li><Link to='/contact'>Contact</Link></li>
                            <li><Link to='/about'>About</Link></li>
                        </ul>
                    </div>
                    {/* <div className="navbar-end">
                        <Link className="btn btn-sm" to='/login'>Login</Link>
                    </div> */}
                </div>


            </div>

        </div>
    );
};

export default Header;